(function() {
  'use strict';

  /**
   * Contrôleur pour la page de test utilisateur
   */
  angular
    .module('observatoireApp')
    .controller('TestController', ['$scope', '$http', function($scope, $http) {
      
      $scope.creating = false;
      $scope.checking = false;
      $scope.counting = false;
      
      // Création directe d'un utilisateur via le repository
      $scope.createUserDirect = function() {
        $scope.creating = true;
        $scope.createResult = null;
        
        $http.post('/api/user-test/create-direct')
          .then(function(response) {
            console.log('Création utilisateur réussie:', response.data);
            $scope.createResult = response.data;
          })
          .catch(function(error) {
            console.error('Erreur lors de la création:', error);
            $scope.createResult = {
              error: true,
              message: error.data || 'Erreur de serveur'
            };
          })
          .finally(function() {
            $scope.creating = false;
          });
      };
      
      // Vérifier l'existence d'un utilisateur
      $scope.checkUser = function() {
        if (!$scope.usernameToCheck) {
          alert('Veuillez entrer un nom d\'utilisateur à vérifier');
          return;
        }
        
        $scope.checking = true;
        $scope.checkResult = null;
        
        $http.get('/api/user-test/check/' + encodeURIComponent($scope.usernameToCheck))
          .then(function(response) {
            console.log('Vérification utilisateur réussie:', response.data);
            $scope.checkResult = response.data;
          })
          .catch(function(error) {
            console.error('Erreur lors de la vérification:', error);
            $scope.checkResult = {
              error: true,
              message: error.data || 'Erreur de serveur'
            };
          })
          .finally(function() {
            $scope.checking = false;
          });
      };
      
      // Compter les utilisateurs
      $scope.countUsers = function() {
        $scope.counting = true;
        $scope.countResult = null;
        
        $http.get('/api/user-test/count')
          .then(function(response) {
            console.log('Comptage utilisateurs réussi:', response.data);
            $scope.countResult = response.data;
          })
          .catch(function(error) {
            console.error('Erreur lors du comptage:', error);
            $scope.countResult = {
              error: true,
              message: error.data || 'Erreur de serveur'
            };
          })
          .finally(function() {
            $scope.counting = false;
          });
      };
    }]);
})();
